import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import useWallet from "../../../../../hooks/useWallet";
import useDepositAddressDestinations from "../../../../../hooks/useDepositAddressDestinations";
import { Selector, SelectorContent, SelectorTrigger } from "../../../../../components/Select/Selector/Index";
import { SelectedRouteDisplay } from "../../../../../components/Input/RoutePicker/Routes";
import { Content } from "../../../../../components/Input/RoutePicker/Content";
import { groupRoutes } from "../../../../../hooks/useFormRoutes";
import { useRecentNetworksStore } from "../../../../../stores/recentRoutesStore";
import { useRouteSortingStore } from "../../../../../stores/routeSortingStore";
import useSuggestionsLimit from "../../../../../hooks/useSuggestionsLimit";
import DestinationWalletPicker from "./DestinationWalletPicker";
import { useSwapRouteRecency } from "../../../../../stores/swapRouteHistoryStore";
const ReceivePicker = ({ selectedDestination, onDestinationChange, destinationAddress, destination, routes, hideWalletPicker, }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const { wallets } = useWallet();
    const { suggestionsLimit } = useSuggestionsLimit({ hasWallet: wallets.length > 0 });
    const sortingOption = useRouteSortingStore((s) => s.sortingOption);
    const routesHistory = useRecentNetworksStore(state => state.recentRoutes);
    const swapRecency = useSwapRouteRecency();
    // Skip the network fetch entirely when the caller supplies a fixed route set.
    const { data: destinationRoutesData } = useDepositAddressDestinations({ enabled: !routes });
    const availableRoutes = useMemo(() => {
        const source = routes ?? destinationRoutesData?.data;
        if (!source)
            return [];
        return source
            .map(route => ({ ...route, tokens: route.tokens?.filter(t => t.status === 'active') ?? [] }))
            .filter(route => route.tokens.length > 0);
    }, [routes, destinationRoutesData]);
    const routeElements = useMemo(() => {
        return groupRoutes({
            routes: availableRoutes,
            direction: 'to',
            balances: null,
            groupBy: 'token',
            recents: routesHistory,
            swapRecency,
            balancesLoaded: false,
            search: searchQuery,
            suggestionsLimit,
            sortingOption,
            skipBalanceGate: true,
            hideSuggestions: true,
        });
    }, [availableRoutes, searchQuery, routesHistory, swapRecency, suggestionsLimit, sortingOption]);
    const hasMultipleOptions = availableRoutes.length > 1 || availableRoutes.some(r => r.tokens.length > 1);
    return (_jsxs("div", { className: "flex items-center gap-2", children: [_jsx("span", { className: "w-24 shrink-0 text-sm text-secondary-text tracking-wide", children: "Receive" }), _jsxs("div", { className: "flex-1 min-w-0 flex items-center gap-2", children: [_jsx("div", { className: "flex-1 min-w-0", children: _jsxs(Selector, { children: [_jsx(SelectorTrigger, { disabled: !hasMultipleOptions, className: "bg-secondary-500 hover:bg-secondary-400/70 rounded-xl px-3.5 py-3 transition-colors", children: _jsx(SelectedRouteDisplay, { route: selectedDestination?.network, token: selectedDestination?.token, placeholder: "Select destination" }) }), _jsx(SelectorContent, { isLoading: false, children: ({ closeModal }) => (_jsx(Content, { onSelect: (r, t) => { onDestinationChange(r, t); closeModal(); }, searchQuery: searchQuery, setSearchQuery: setSearchQuery, rowElements: routeElements, direction: "to", selectedRoute: selectedDestination?.network.name, selectedToken: selectedDestination?.token.symbol, hideTokenSwitch: true, hideBalances: true })) })] }) }), !hideWalletPicker && (_jsx("div", { className: "flex-1 min-w-0", children: _jsx(DestinationWalletPicker, { address: destinationAddress, destination: destination, token: selectedDestination?.token }) }))] })] }));
};
export default ReceivePicker;
